export default {
  fontSize: 13,
  spacing: 10,
  green: '#62ac1e',
  orange: '#f8961d',
  gray: '#333333',
  lightgray: '#dbdbdb',
  qlikGreen: '#009845',
  stone: '#C4CFDA',
  container: {
    maxWidth: '1320px',
    margin: '0 auto',
    padding: '0 20px',
    position: 'relative',
  },
  btnOutline: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    boxSizing: 'border-box',
    border: '2px solid #009845',
    borderRadius: '30px',
    padding: '0 18px',
    fontSize: '1em',
    color: '#009845',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'all .25s ease-in-out',
    backgroundColor: 'transparent',
    height: '40px',
    '&:hover': {
      backgroundColor: '#009845',
      color: '#FFFFFF',
    },
  },
  btnFilled: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    boxSizing: 'border-box',
    border: '2px solid #009845',
    borderRadius: '30px',
    padding: '0 18px',
    fontSize: '1em',
    lineHeight: '1em',
    color: '#FFFFFF',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'all .25s ease-in-out',
    backgroundColor: '#009845',
    cursor: 'pointer',
    height: '40px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#009845',
    },
  },
};
